import {
  ManagementPartyDto,
  PartyManualQuotationExchangeChannelDto,
  PartyQuotationExchangeChannelDto,
  PartyScsnQuotationExchangeChannelDto,
  QuotationExchangeChannel,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { PartyEmailChannel } from 'controllers/System/PartyEmailChannelCompatibility'

export type PartyQuotationExchangeChannel =
  | PartyManualQuotationExchangeChannelDto
  | PartyScsnQuotationExchangeChannelDto
  | PartyEmailChannel
  | PartyQuotationExchangeChannelDto

const isPartyQuotationExchangeChannel = (
  value: unknown,
): value is PartyQuotationExchangeChannel => {
  if (!value || typeof value !== 'object') return false
  const channel = value as Record<string, unknown>
  return (
    typeof channel.id === 'string' &&
    typeof channel.channel === 'string' &&
    typeof channel.isEnabled === 'boolean'
  )
}

export const getPartyQuotationExchangeChannels = (party: ManagementPartyDto) =>
  ((party.quotationExchangeChannels || []) as readonly unknown[]).filter(
    isPartyQuotationExchangeChannel,
  )

export const isManualChannel = (
  channel: PartyQuotationExchangeChannel,
): channel is PartyManualQuotationExchangeChannelDto =>
  channel.channel === QuotationExchangeChannel.Manual

export const isScsnChannel = (
  channel: PartyQuotationExchangeChannel,
): channel is PartyScsnQuotationExchangeChannelDto =>
  channel.channel === QuotationExchangeChannel.Scsn

export const isEmailChannel = (
  channel: PartyQuotationExchangeChannel,
): channel is PartyEmailChannel =>
  channel.channel === QuotationExchangeChannel.Email
